import { _ as _baseIsTypedArray } from "./auth-service-tools1204.js";
import { _ as _baseUnary } from "./auth-service-tools1205.js";
import { _ as _nodeUtilExports } from "./auth-service-tools1206.js";
var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
export { isTypedArray_1 as i };